import dayjs from 'dayjs'

export function formatDate(date: Date) {
  return dayjs(date).format('DD/MM/YYYY')
}

export function getISODate(date: string) {
  const splittedDate = date.split('/')
  const day = splittedDate[0]
  const month = splittedDate[1]
  const year = splittedDate[2]
  const orderedDate = `${year}-${month}-${day}`
  const correctDate = new Date(orderedDate).toISOString()
  return correctDate
}
